var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "empty-state",
      attrs: { column: "", "align-center": "", "justify-center": "" }
    },
    [
      _c("img", {
        attrs: { height: "150", src: "/static/LTN_Empty_State.png" }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "font-weight-bold title" }, [
        _vm._v(_vm._s(_vm.message))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2b92118", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b92118","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmptyState.vue
// module id = null
// module chunks = 